import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectLMScoursesListItems } from "../../../../../redux/lms/courses/selector";
import { lmsCourses } from "../../../../../redux/lms/courses/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";


const ManagementLMSCourses = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const lmsCoursesItemsData = useSelector(selectLMScoursesListItems);
    const [columnDefs, setColumnDefs] = useState({});
    
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },
            { field: 'Title', headerName: 'Title',searchField: 'Title', sortable: true, filter: true, filterType: 'text' },
            { field: 'Author', headerName: 'Author' },
            { field: 'NumModules', headerName: 'Number Of Modules' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    };

    const fetchLMSCoursesList = () => {
        dispatch(lmsCourses.list({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/list`,
            entity: 'lmsCourses',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            },
        }));
    };

    useEffect(() => {
        createColumnDefs();
        fetchLMSCoursesList();
    }, [pageData, pageSize]);

    const handleAdd = () => {
        navigate(`${0}`);
    };


    const handleDelete = (data: any) => {
        dispatch(lmsCourses.delete({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/delete`,
            entity: 'lmsCourses',
            jsonData: {
                records: [
                    {
                        id: data?.Id,
                    },
                ],
            },
        })).then(() => {
            fetchLMSCoursesList();
        });
    };

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchLMSCoursesList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Course</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Title",
            FieldText: "Title",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }

        dispatch(lmsCourses.list({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/list`,
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }));
    };

    


    return (
        <>
            {lmsCoursesItemsData?.isLoading ? (
                <PageLoader />
            ) : (
                <Table 
                checkboxConfig={{
                  allowMultiSelect: true,
                  defaultSelectedIds: [],
                  isDisabled: false,
                  keyColumn: 'Id',
                }}
                    columnData={columnDefs} 
                    rowData={lmsCoursesItemsData?.result?.items} 
                    setPageData={setPageData}
                    setPageSize={setPageSize} 
                    enableFilter={true}
                    onSearch={handleSearch} 
                    paginationData={lmsCoursesItemsData?.result?.pagination}
                    additionButtons={additionButtons} 
                    onEdit={handleEdit} 
                    onDelete={handleDelete}
                    headingName="Courses"
                />
            )}
        </>
    );
};

export default ManagementLMSCourses;


